import CasAlertDialog from './CasAlertDialog';
import CasButton from '../CasButton/CasButton';

export default function CasConfirmationDialog({
  open,
  title = '',
  children,
  confirmLabel = 'OK',
  onConfirm,
  onCancel,
  confirmDisabled = false,
}: any) {
  return (
    <CasAlertDialog
      {...{ open, title, onClose: onCancel }}
      actions={
        <>
          <CasButton color="secondary" variant="outlined" onClick={onCancel}>
            Cancel
          </CasButton>
          <CasButton onClick={onConfirm} disabled={confirmDisabled} >{confirmLabel}</CasButton>
        </>
      }
    >
      {children}
    </CasAlertDialog>
  );
}
